export class loginmodel {
  "SignInEmail"			: string = "";
  "consumerId"			: string = "";
  "SignInPass"			: string = "";
  "forgotConsumer"		: string = "";
  "consumerOtp" 		: string = "";
  "emailId" : string = "";
  "paymentMode" : string = "";
}


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/login/login.model.ts